// user-client/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/lobby-new-design.css';
import './styles/npc-approved-desktop.css';
import './styles/npc-approved-desktop-table.css';
import './styles/npc-approved-mobile.css';
import './styles/npc-approved-mobile-table.css';
import './styles/npc-approved-integration.css';
import './styles/npc-responsive-typography.css';
import './shared/utils/mobileViewportGuard';
import './shared/utils/pwaIconLinks';
import './shared/utils/pwaInstallPromptBridge';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { I18nProvider, preloadInitialTranslations } from './i18n/I18nProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));

function mountApp() {
  // A global PokerProvider used to live here even though every table owns its own
  // isolated PokerProvider. Removing the unused global provider avoids constructing
  // the large poker state tree on login/lobby startup.
  root.render(
    <I18nProvider>
      <App />
    </I18nProvider>
  );
}

// Load only English + the user's selected language before first paint. All other
// language bundles stay out of the initial bundle and are fetched only when selected.
void preloadInitialTranslations()
  .catch(() => {})
  .finally(mountApp);

reportWebVitals();
